import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PricingModalComponent } from '../pricing-modal/pricing-modal.component';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { PricingService } from 'src/app/services/pricing.service';
import { LanguageFlag } from '../language-selector-front-end/language-selector-front-end.component';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslationService } from 'src/app/shared/i18n/translation.service';
import { LookUpService } from 'src/app/services/lookup.service';
import { environment } from 'src/environments/environment.prod';

@Component({
    selector: 'app-header-style-one',
    templateUrl: './header-style-one.component.html',
    styleUrls: ['./header-style-one.component.css'],
    standalone: false
})
export class HeaderStyleOneComponent implements OnInit {

    constructor(private modalService: NgbModal, private router: Router
        , public authService: AuthenticationService, public pricingService: PricingService, private translationService: TranslationService,
        public lookupService: LookUpService
    ) { }
    userName: string | null = null;
    token: string | null = null;
    packagesCount: number = 0;
    isLoading: boolean;
    isSticky = false;
    sidebarLogo: string = 'https://localhost:7285/AttachmentsFile/2dbc651d-3785-4be4-8734-0f80439766d0.png';
    
    ngOnInit(): void {
        this.lookupService.getAll$().subscribe(lookups => {
            if (lookups) {
                const logoSetting = lookups.find((x: any) => x?.name == "LogoHeader");
                if (logoSetting && logoSetting.value) {
                    const imgUrl = this.createImgPath(logoSetting.value);
                    if (imgUrl) {
                        this.sidebarLogo = imgUrl;
                    }
                }
            }
        });
        this.setSelectedLanguage();
        this.router.events
            .pipe(filter((event) => event instanceof NavigationStart))
            .subscribe((event) => {
                this.setSelectedLanguage();
            });
        this.token = localStorage.getItem('token');
        this.userName = localStorage.getItem('userName');
        this.pricingService.getAllUserPayments$(false).subscribe(x => {
            this.packagesCount = x.length
        });
        
        // Add scroll event listener for sticky header
        window.addEventListener('scroll', () => {
            this.isSticky = window.scrollY > 100;
        });
    }

    classApplied = false;
    toggleClass() {
        this.classApplied = !this.classApplied;
    }

    classApplied2 = false;
    toggleClass2() {
        this.classApplied2 = !this.classApplied2;
    }

    classApplied3 = false;
    toggleClass3() {
        this.classApplied3 = !this.classApplied3;
    }
    logout() {

        this.authService.logout();
    }
    choosePackage() {
        const modalRef = this.modalService.open(PricingModalComponent, { size: 'xl' });
        modalRef.result.then(() =>
            () => {
                this.isLoading = false

            }
        );
    }
 
    language: LanguageFlag = new LanguageFlag();
    setLanguageWithRefresh(lang: any) {
        this.setLanguage(lang);
        document.documentElement.setAttribute('lang', 'de');
        window.location.reload();
    }
    setLanguage(lang: any) {
        this.languages.forEach((language: LanguageFlag) => {
            if (language.lang === lang) {
                language.active = true;
                this.language = language;
            } else {
                language.active = false;
            }
        });
        this.translationService.setLanguage(lang);
    }
    languages: LanguageFlag[] = [
        {
            lang: 'en',
            name: 'En',
            flag: './assets/img/us-flag.jpg',
        },
        {
            lang: 'de',
            name: 'Ger',
            flag: './assets/img/germany-flag.jpg',
        }
    ];
    setSelectedLanguage(): any {
        this.setLanguage(this.translationService.getSelectedLanguage());
    }

    createImgPath = (serverPath: string) => {
        if (serverPath)
            return `${environment.patchUrl}/${serverPath}`;
    }
}